export const CONNECTION_TYPES = {
  CONNECTED: 'Connected',
  'NOT CONNECTED': 'Not Connected',
  EXPIRED: 'Expired',
} as const;

export type ConnectionType =
  (typeof CONNECTION_TYPES)[keyof typeof CONNECTION_TYPES];

export enum CONNECTION_BUTTON_TYPES {
  'RECONNECT',
  'DISCONNECT',
}

export const privacyOptions = [
  {
    value: 'private',
    text: 'Private',
  },
  {
    value: 'public',
    text: 'Public',
  },
  {
    value: 'unlisted',
    text: 'Unlisted',
  },
];
